import { render, staticRenderFns } from "./SettingsLinks.vue?vue&type=template&id=7699d8ef&"
import script from "./SettingsLinks.vue?vue&type=script&lang=js&"
export * from "./SettingsLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports